var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      !_vm.loading
        ? _c(
            "v-card-text",
            [
              _c(
                "v-layout",
                { attrs: { wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm12: "", md4: "" } },
                    [
                      _c("v-text-field", {
                        staticClass: "title-branding custom-input",
                        attrs: {
                          filled: "",
                          label: "ID",
                          type: "text",
                          readonly: ""
                        },
                        model: {
                          value: _vm.client.current_policy.PolicyMasterID,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.client.current_policy,
                              "PolicyMasterID",
                              $$v
                            )
                          },
                          expression: "client.current_policy.PolicyMasterID"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm12: "", md4: "" } },
                    [
                      _c("v-text-field", {
                        staticClass: "title-branding custom-input",
                        attrs: {
                          filled: "",
                          label: "Code",
                          type: "text",
                          readonly: ""
                        },
                        model: {
                          value: _vm.client.current_policy.PolicyMasterCode,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.client.current_policy,
                              "PolicyMasterCode",
                              $$v
                            )
                          },
                          expression: "client.current_policy.PolicyMasterCode"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm12: "", md4: "" } },
                    [
                      _c("v-text-field", {
                        staticClass: "title-branding custom-input",
                        attrs: {
                          filled: "",
                          label: "Status",
                          type: "text",
                          readonly: ""
                        },
                        model: {
                          value: _vm.client.current_policy.Status,
                          callback: function($$v) {
                            _vm.$set(_vm.client.current_policy, "Status", $$v)
                          },
                          expression: "client.current_policy.Status"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm12: "", md6: "" } },
                    [
                      _c("v-text-field", {
                        staticClass: "title-branding custom-input",
                        attrs: {
                          filled: "",
                          label: "Commencement",
                          type: "text",
                          readonly: ""
                        },
                        model: {
                          value: _vm.client.current_policy.CommencementDate,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.client.current_policy,
                              "CommencementDate",
                              $$v
                            )
                          },
                          expression: "client.current_policy.CommencementDate"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm12: "", md6: "" } },
                    [
                      _c("v-text-field", {
                        staticClass: "title-branding custom-input",
                        attrs: {
                          filled: "",
                          label: "Will Status",
                          type: "text",
                          readonly: ""
                        },
                        model: {
                          value: _vm.client.current_policy.WillStatus,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.client.current_policy,
                              "WillStatus",
                              $$v
                            )
                          },
                          expression: "client.current_policy.WillStatus"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { xs12: "" } }, [
                    _c("h3", [_vm._v("Plan details")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm12: "", md6: "" } },
                    [
                      _c("v-text-field", {
                        staticClass: "title-branding custom-input",
                        attrs: {
                          filled: "",
                          label: "Product",
                          type: "text",
                          readonly: ""
                        },
                        model: {
                          value:
                            _vm.client.current_policy.plan_details.product_name,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.client.current_policy.plan_details,
                              "product_name",
                              $$v
                            )
                          },
                          expression:
                            "client.current_policy.plan_details.product_name"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm12: "", md6: "" } },
                    [
                      _c("v-text-field", {
                        staticClass: "title-branding custom-input",
                        attrs: {
                          filled: "",
                          label: "Plan",
                          type: "text",
                          readonly: ""
                        },
                        model: {
                          value:
                            _vm.client.current_policy.plan_details.product_plan,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.client.current_policy.plan_details,
                              "product_plan",
                              $$v
                            )
                          },
                          expression:
                            "client.current_policy.plan_details.product_plan"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm12: "", md6: "" } },
                    [
                      _c(
                        "v-currency-field",
                        _vm._b(
                          {
                            staticClass: "title-branding custom-input",
                            attrs: {
                              label: "Premium",
                              type: "tel",
                              filled: "",
                              readonly: ""
                            },
                            model: {
                              value:
                                _vm.client.current_policy.plan_details.premium,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.client.current_policy.plan_details,
                                  "premium",
                                  $$v
                                )
                              },
                              expression:
                                "client.current_policy.plan_details.premium"
                            }
                          },
                          "v-currency-field",
                          _vm.$root.currency_config,
                          false
                        )
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm12: "", md6: "" } },
                    [
                      _c(
                        "v-currency-field",
                        _vm._b(
                          {
                            staticClass: "title-branding custom-input",
                            attrs: {
                              label: "Value to beneficiaries",
                              type: "tel",
                              filled: "",
                              readonly: ""
                            },
                            model: {
                              value:
                                _vm.client.current_policy.plan_details
                                  .value_beneficiaries_total,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.client.current_policy.plan_details,
                                  "value_beneficiaries_total",
                                  $$v
                                )
                              },
                              expression:
                                "client.current_policy.plan_details.value_beneficiaries_total"
                            }
                          },
                          "v-currency-field",
                          _vm.$root.currency_config_no_decimals,
                          false
                        )
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.files.length
                    ? _c("v-flex", { attrs: { xs12: "" } }, [
                        _c("h3", [_vm._v("Files")])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.files.length
                    ? _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _c(
                            "v-layout",
                            { attrs: { wrap: "", row: "" } },
                            _vm._l(_vm.files, function(file, index) {
                              return _c(
                                "v-flex",
                                {
                                  key: index,
                                  attrs: { xs12: "", sm12: "", md4: "" }
                                },
                                [
                                  _c(
                                    "v-card",
                                    { attrs: { flat: "" } },
                                    [
                                      _c(
                                        "v-card-text",
                                        {
                                          staticClass:
                                            "d-flex justify-center align-center"
                                        },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "mr-2",
                                              attrs: { icon: "" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.viewFile(file)
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    color: _vm.$vuetify.theme
                                                      .dark
                                                      ? "accent"
                                                      : "primary"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                        $mdiEye\n                                    "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            [
                                              _c(
                                                "v-tooltip",
                                                {
                                                  attrs: { bottom: "" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function(ref) {
                                                          var on = ref.on
                                                          return [
                                                            _c(
                                                              "span",
                                                              _vm._g({}, on),
                                                              [
                                                                _vm._v(
                                                                  "\n                                                " +
                                                                    _vm._s(
                                                                      file.name
                                                                    ) +
                                                                    "\n                                            "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                },
                                                [
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(file.pivot.role)
                                                    )
                                                  ])
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _c(
            "v-card-text",
            { staticClass: "d-flex justify-center align-center mh-300" },
            [
              _c("v-progress-circular", {
                attrs: { size: 50, color: "secondary", indeterminate: "" }
              })
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }